import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { useGame, useUser } from 'data/hooks'

export const useRanking = (gameId, rankingId, eventId) => {

  const game = useGame(gameId)
  const [ events, setEvents ] = useState([])
  const [ ranking, setRanking ] = useState()

  useEffect(() => {

    if (
      !rankingId
      || 
      !game.events
      ||
      !Object.values(game.events).length
    ) return
    
    const events = Object.values(game.events)
                          .filter(event => event.rankings[rankingId] !== undefined)
                          .sort((a, b) => {
                            if (a.eventOrder > b.eventOrder) return 1
                            if (a.eventOrder < b.eventOrder) return -1
                            return 0
                          })

    setEvents(events)

    if (events.length === 0) {

      console.log(`No existe ningún evento con el ranking ${rankingId}`)
      
      setRanking(null)

    } else if (eventId && !game.events[eventId]?.rankings[rankingId]) {
        
      console.log(`No existe ningún ranking ${rankingId} para el evento ${eventId}`)

      setRanking(null)

    } else {

      setRanking(game.events[eventId]?.rankings[rankingId])
    }

  }, [rankingId, eventId])

  return {
    events,
    ranking,
  }
}
